// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — item.styled.classic.js, новая — item.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './item.styled.classic';
import * as cp from './item.styled.cp';

export const ButtonWrapper = isCp ? undefined : classic.ButtonWrapper;
export const CardHead = isCp ? cp.CardHead : undefined;
export const Content = isCp ? cp.Content : classic.Content;
export const PhotoPlace = isCp ? cp.PhotoPlace : classic.PhotoPlace;
export const Refresh = isCp ? cp.Refresh : classic.Refresh;
export const Title = isCp ? cp.Title : classic.Title;
